/// <reference path="../../../../../typings/jquery.d.ts"/>

import { User } from '../../../../../../shared/models/api/User/User';
import { BasicApplicationRouter } from '../../../../../../shared/services/BasicApplicationRouter';
import { ViewConfiguration } from '../../../../../../shared/services/BasicViewService';
import { AppViewService } from '../../services/AppViewService';
import { AppUtils } from '../../../../../../shared/utils/index';

export class OverviewPageController implements StepController {
	private readonly $ctx: JQuery;
	private readonly options: BasicAppOptions<LocalAppDefinition>;
	private readonly appViewService: AppViewService;
	private readonly parent: AppController;
	private readonly loader: BasicLoader<LocalAppDefinition>;
	private readonly applicationRouter: BasicApplicationRouter<LocalAppDefinition>;
	private readonly user: User;

	constructor(parent: AppController, options: BasicAppOptions<LocalAppDefinition>, loader: BasicLoader<LocalAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.loader = loader;
		this.$ctx = $(options.$ctx);
		this.appViewService = new AppViewService(parent, options, loader);
		this.applicationRouter = new BasicApplicationRouter(this.options);
		this.user = user;
	}

	public start(): void {
		const viewConfig: ViewConfiguration<LocalAppDefinition> = {
			data: this.getViewOptions(),
			templateurl: this.options.app.currenttemplate.templateurl,
			campaignurls: this.options.app.campaignurls,
			parent: this,
			$ctx: this.$ctx,
			options: this.options,
			callback: this.afterRenderApp
		};
		this.appViewService.render(viewConfig);
	}

	private getViewOptions(): { [key: string]: any } {
		return {
			IsVerified: this.user.Verified
		};
	}

	public afterRenderApp(): void {
		this.loader.loadSubApps({ options: this.options }, () => {
			this.parent.afterRenderApp();

			if (!this.user.UserData.Mitgliedschaft.Firma) {
				this.appViewService.addOverviewPageListener(this.requestInformationListener.bind(this));
			}
			else {
				this.appViewService.hideRequestInformationBtn();
			}
			AppUtils.View.stopLoader();
			AppUtils.View.scrollTop();
		});
	}

	private requestInformationListener(e: JQuery.Event): void {
		e.preventDefault();
		AppUtils.View.startLoader();
		this.applicationRouter.next();
	}
}